/* index.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["tooltip"],
  _excluded2 = ["ref"];
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Fragment, useCallback, useEffect, useState } from 'react';
import { EngagementSpotlight, useCoordination } from '@atlassiansox/engagekit-ts';
import { useIntl } from 'react-intl-next';
import { di } from 'react-magnetic-di';
import { PrimaryButton } from '@atlaskit/atlassian-navigation';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { TopNavButton } from '@atlaskit/navigation-system/experimental/top-nav-button';
import { SpotlightManager, SpotlightPulse, SpotlightTarget } from '@atlaskit/onboarding';
import { fg } from '@atlaskit/platform-feature-flags';
import Tooltip from '@atlaskit/tooltip';
import { useAnalytics } from '@atlassian/conversation-assistant-instrumentation';
import { ConversationAssistantOnboardingSpotlight, SPOTLIGHT_ONBOARDING_TARGET, useConversationAssistantSpotlightActions, useConversationAssistantSpotlightState, useCoordinationClient } from '@atlassian/conversation-assistant-onboarding';
import { ChatIcon } from '../../common/ui/chat-icon';
import { messages } from './messages';
var defaultButtonStyles = {
  paddingInline: '8px'
};
var inactiveButtonStyles = {
  background: "var(--ds-background-neutral, #091E420F)"
};
var disabledButtonStyles = {
  background: "var(--ds-background-disabled, #091E4208)",
  color: "var(--ds-text-disabled, #091E424F)"
};
export var ConditionalWrapper = function ConditionalWrapper(_ref) {
  var condition = _ref.condition,
    wrapper = _ref.wrapper,
    children = _ref.children;
  return condition ? wrapper(children) : children;
};
var getConversationAssistantButton = function getConversationAssistantButton() {
  var Button = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : PrimaryButton;
  return function (_ref2) {
    var testId = _ref2.testId,
      isActive = _ref2.isActive,
      _ref2$isDisabled = _ref2.isDisabled,
      isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled,
      onClickProp = _ref2.onClick,
      tooltipContent = _ref2.tooltipContent,
      siteId = _ref2.siteId,
      productKey = _ref2.productKey;
    var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;
    var _useConversationAssis = useConversationAssistantSpotlightActions(),
      start = _useConversationAssis.start;
    var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      shouldShowMessage = _useState2[0],
      setShouldShowMessage = _useState2[1];
    var messageId = productKey === 'confluence' ? 'confluence_rovo_chat_agents_spotlight_ga' : productKey === 'jira' ? 'jira_rovo_chat_agents_spotlight_ga' : '';
    var shouldUseCoordination = !!messageId;
    var _useAnalytics = useAnalytics(),
      sendAnalyticsEvent = _useAnalytics.sendAnalyticsEvent;
    var openRovoChat = function openRovoChat(event, analyticsEvent) {
      if (!isActive && onClick) {
        onClick(event, analyticsEvent);
      }
    };
    var onClick = useCallback(function () {
      sendAnalyticsEvent({
        eventType: 'ui',
        action: 'clicked',
        actionSubject: 'rovoChatButton',
        attributes: {
          isActive: isActive,
          isDisabled: isDisabled,
          productKey: productKey
        }
      });
      for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
        params[_key] = arguments[_key];
      }
      return onClickProp === null || onClickProp === void 0 ? void 0 : onClickProp.apply(void 0, params);
    }, [isActive, isDisabled, onClickProp, productKey, sendAnalyticsEvent]);
    var interactionName = isActive ? 'close-rovo-chat-nav-button' : 'open-rovo-chat-nav-button';
    var getChildren = function getChildren() {
      return /*#__PURE__*/React.createElement(Button, {
        onMouseEnter: function onMouseEnter() {
          if (shouldShowMessage) {
            sendAnalyticsEvent({
              eventType: 'ui',
              action: 'hovered',
              actionSubject: 'rovoChatButtonSpotlight'
            });
            start();
          }
        },
        testId: testId,
        isSelected: isActive,
        onClick: onClick,
        isDisabled: isDisabled,
        tooltip: tooltipContent !== null && tooltipContent !== void 0 ? tooltipContent : /*#__PURE__*/React.createElement(Fragment, null, fg('rovo_chat_top_nav_button_label') ? formatMessage(messages.rovoChatButtonLabel) : formatMessage(messages.buttonLabel)),
        style: _objectSpread(_objectSpread(_objectSpread({}, defaultButtonStyles), !isActive && inactiveButtonStyles), isDisabled && disabledButtonStyles),
        iconBefore: /*#__PURE__*/React.createElement(ChatIcon, null),
        interactionName: interactionName
      }, fg('rovo_chat_top_nav_button_label') ? formatMessage(messages.rovoChatButtonLabel) : formatMessage(messages.buttonLabel));
    };
    return shouldUseCoordination ? /*#__PURE__*/React.createElement(SpotlightWrapper, {
      setShouldShowMessage: setShouldShowMessage,
      messageId: messageId,
      siteId: siteId,
      children: getChildren(),
      shouldShowMessage: shouldShowMessage,
      openRovoChat: openRovoChat
    }) : getChildren();
  };
};
export var ConversationAssistantButton = getConversationAssistantButton(PrimaryButton);
export var ConversationAssistantButtonNav4 = getConversationAssistantButton(function Nav4Button(_ref3) {
  var tooltip = _ref3.tooltip,
    props = _objectWithoutProperties(_ref3, _excluded);
  return /*#__PURE__*/React.createElement(Tooltip, {
    content: tooltip
    // This button's visible text matches the tooltip
    // Announcing the tooltip means 'Chat' would be announced twice
    ,
    isScreenReaderAnnouncementDisabled: true
  }, function (_ref4) {
    var ref = _ref4.ref,
      triggerProps = _objectWithoutProperties(_ref4, _excluded2);
    return /*#__PURE__*/React.createElement(TopNavButton, _extends({
      interactionName: props === null || props === void 0 ? void 0 : props.interactionName,
      ref: ref
    }, triggerProps, props, {
      onClick: function onClick(event, analyticsEvent) {
        var _props$onClick, _triggerProps$onClick;
        (_props$onClick = props.onClick) === null || _props$onClick === void 0 || _props$onClick.call(props, event, analyticsEvent);
        (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, event);
      },
      iconBefore: function iconBefore() {
        return props.iconBefore || null;
      }
    }));
  });
});
export var SpotlightWrapper = function SpotlightWrapper(_ref5) {
  var children = _ref5.children,
    messageId = _ref5.messageId,
    siteId = _ref5.siteId,
    setShouldShowMessage = _ref5.setShouldShowMessage,
    shouldShowMessage = _ref5.shouldShowMessage,
    openRovoChat = _ref5.openRovoChat;
  var _useConversationAssis2 = useConversationAssistantSpotlightState(),
    activeSpotlight = _useConversationAssis2.activeSpotlight;
  var coordinationClient = useCoordinationClient(siteId);
  var _useCoordination = useCoordination(coordinationClient, messageId),
    _useCoordination2 = _slicedToArray(_useCoordination, 2),
    onboardingStarted = _useCoordination2[0],
    stopOnboarding = _useCoordination2[1];
  var _useAnalytics2 = useAnalytics(),
    sendAnalyticsEvent = _useAnalytics2.sendAnalyticsEvent;
  var onDismissMessage = function onDismissMessage() {
    setShouldShowMessage(false);
    stopOnboarding();
  };
  useEffect(function () {
    if (shouldShowMessage && activeSpotlight !== null) {
      sendAnalyticsEvent({
        eventType: 'ui',
        action: 'shown',
        actionSubject: 'rovoChatButtonSpotlight'
      });
    }
  }, [shouldShowMessage, activeSpotlight, sendAnalyticsEvent]);
  useEffect(function () {
    if (onboardingStarted) {
      setShouldShowMessage(true);
    }
  }, [onboardingStarted, setShouldShowMessage]);
  return /*#__PURE__*/React.createElement(ConditionalWrapper, {
    condition: shouldShowMessage,
    wrapper: function wrapper(children) {
      return /*#__PURE__*/React.createElement(SpotlightManager, {
        blanketIsTinted: true
      }, /*#__PURE__*/React.createElement(SpotlightTarget, {
        name: SPOTLIGHT_ONBOARDING_TARGET
      }, /*#__PURE__*/React.createElement(SpotlightPulse, {
        radius: 3,
        pulse: activeSpotlight === null
      }, children, /*#__PURE__*/React.createElement(ConversationAssistantOnboardingSpotlight, {
        onDismiss: onDismissMessage,
        openRovoChat: openRovoChat
      }), /*#__PURE__*/React.createElement(EngagementSpotlight, {
        engagementId: SPOTLIGHT_ONBOARDING_TARGET
      }))));
    }
  }, children);
};